import { cloneDeep } from "lodash";
import { IFieldAction, IFormAction, IFormState } from "./formInterfaces";

export const log = ({
  action,
  preState,
  nextState
}: {
  action: IFieldAction | IFormAction;
  preState: IFormState;
  nextState: IFormState;
}) => {
  if (process.env.NODE_ENV === "development") {
    console.groupCollapsed(`${action.type} ${new Date()}`);
    console.log("preState", cloneDeep(preState));
    console.log("action", cloneDeep(action));
    console.log("nextState", cloneDeep(nextState));
    console.groupEnd();
  }
};

export const isNil = (value: any) => [null, undefined, ""].includes(value);
export const isEmpty = (value: any) => {
  if (Array.isArray(value)) {
    return value.length === 0;
  }
  if (value.constructor === Object) {
    return Object.keys(value).length === 0;
  }

  return false;
};
